<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="New Applicants"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('new_applicants')
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use New Appplicants
      (External) Tool.
    </div>

    <!-------------------- NEW APPLICANTS HELP GUIDE -------------------->
    <div class="tool-div">
      <div
        class="left-align-div"
        *ngIf="authService.hasPermission('&tabname=ftic_new_applicants')"
      >
        <h1 class="h1-header">
          Admin Support (External) <i class="fa-solid fa-arrow-right"></i> New
          Applicants
        </h1>

        <h3 class="h3-second-header">Goals for New Applicants tool</h3>

        <ul class="unordered-list">
          <li>
            Predict risk-level for new applicants. The models used predict the
            periodic risk-level for students
          </li>
        </ul>

        <h3 class="h3-second-header">New Applicants Submission</h3>

        <ol class="ordered-list">
          <li>
            Upload a new applicant dataset by uploading a file from your
            computer.
          </li>
          <li>Select a risk-model after to generate the risk-levels.</li>

          <img
            class="set-img-width-med"
            [(src)]="env['logo_paths']['helpPageNewAplicants52']"
            alt=""
          />
          <p class="picture-caption">
            Figure 52: Form field to upload file for analysis
          </p>

          <img
            class="set-img-width-med"
            [(src)]="env['logo_paths']['helpPageNewAplicants53']"
            alt=""
          />
          <p class="picture-caption">
            Figure 53: Form field to choose a risk-model
          </p>
        </ol>

        <h3 class="h3-second-header">Results after uploading a file</h3>

        <ul class="unordered-list">
          <li>
            After uploading a file and the data has generated, the final
            predicted dataset will be generated, and you can download it.
          </li>
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageNewAplicants54']"
            alt=""
          />
          <p class="picture-caption">
            Figure 54: Information about possible predictors and predictive
            models
          </p>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getExternalAdminSupportRelatedLinkBasedOnTool(
        'New Applicants',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
